import { useOrgContext } from '@/org/contexts/OrgContext'
import { useOnboardingActivitySubscription } from '@gql'

// Whether the org already has a recurring meeting, a held meeting, a thread,
// a decision, a project, and a role with each of its written fields (#120)
export default function useOnboardingActivity(skip = false) {
  const { orgId } = useOrgContext()
  const { data, loading } = useOnboardingActivitySubscription({
    skip: skip || !orgId,
    variables: { orgId: orgId! },
  })

  const org = data?.org_by_pk
  return {
    loading: loading || !data,
    hasRecurringMeeting: !!org?.meetings_recurring.length,
    hasHeldMeeting: !!org?.meetings.length,
    hasThread: !!org?.threads.length,
    hasDecision: !!org?.decisions.length,
    hasTask: !!org?.tasks.length,
    hasPurpose: !!org?.rolesWithPurpose.length,
    hasAccountabilities: !!org?.rolesWithAccountabilities.length,
    hasChecklist: !!org?.rolesWithChecklist.length,
    hasIndicators: !!org?.rolesWithIndicators.length,
  }
}
